import { isArray, each, map, invokeMap, defer, mapValues } from 'lodash-es';
import { TinyEmitter } from 'tiny-emitter';
import { getRoot, updatePageLinks } from 'core/router';
import tag from 'core/tag';
import store from 'store/store';
export const getRouterData = (string) => {
    const routerData = string?.split('|') || [];
    let path, tagName;
    if (routerData.length === 1) {
        if (!path && ~routerData[0].indexOf('http'))
            path = routerData[0];
        else
            tagName = routerData[0];
    }
    else if (routerData.length === 2) {
        path = routerData[1];
        tagName = routerData[0];
    }
    return { path, tagName };
};
export const forceArray = (a) => (isArray(a) ? a : [a]);
export const unforceArray = (a) => (a.length === 0 ? null : a.length === 1 ? a[0] : a);
export const extractRefs = (target) => {
    const parseRefs = (selector, forceArray, refs) => {
        return Array.from(target.querySelectorAll(`*[${selector}]`)).reduce((memo, el) => {
            const keys = el.getAttribute(selector);
            if (keys) {
                keys.split(/[ ,]+/).forEach((key) => {
                    if (memo[key] || forceArray) {
                        if (!memo[key])
                            memo[key] = [];
                        else if (!isArray(memo[key]))
                            memo[key] = [memo[key]];
                        memo[key].push(el);
                    }
                    else {
                        memo[key] = el;
                    }
                });
            }
            return memo;
        }, refs);
    };
    let refs = parseRefs('data-ref', false, {});
    refs = parseRefs('data-refs', true, refs);
    return refs;
};
class Component extends TinyEmitter {
    el;
    options;
    refs;
    modules;
    binded = false;
    context;
    parent = null;
    routerLinks = [];
    flushed = false;
    constructor(el, options = {}) {
        super();
        this.el = el;
        this.refs = {};
        this.modules = {};
        this.options = options || {};
        this.context = this.options.context || {};
        this.parent = this.options.parent || null;
        this.bindRefs();
        this.bindModules();
        this.bindInternalRouter();
        defer(() => {
            this.initialized();
        });
    }
    initialized() {
        this.bindEvents(true);
    }
    refresh() {
        this.bindEvents(false);
        this.bindRefs();
        this.bindModules();
        this.bindEvents(true);
        updatePageLinks();
        this.resize();
    }
    /* BINDINGS EVENTS */
    bindEvents(add = true) { }
    /* BINDINGS REFS */
    bindRefs(target) {
        if (!target)
            target = this.el;
        this.refs = extractRefs(target);
    }
    /* BINDINGS MODULES */
    bindModules() {
        if (!this.modules)
            this.modules = {};
        const modulesMap = this.getModulesMap();
        if (this.modules) {
            // Clean older
            this.modules = mapValues(this.modules, (modules, key) => {
                return forceArray(modules)?.filter((module) => {
                    if (!module.el ||
                        (module.el.parentElement &&
                            document.body.contains(module.el) &&
                            !!modulesMap[key]))
                        return true;
                    module.flush();
                    return false;
                });
            });
            for (const module in this.modules) {
                if (this.modules[module].length !== undefined && this.modules[module].length === 0)
                    delete this.modules[module];
            }
        }
        each(modulesMap, ([selector, Module, events, options], key) => {
            if (!Module)
                return;
            const array = map((selector === 'self' ? [this.el] : this.el.querySelectorAll(selector)), (el) => {
                // if (el.binded && ~el.binded.indexOf(key)) return
                const alreadyExist = !!forceArray(this.modules?.[key])?.find((m) => m?.el === el);
                if (alreadyExist)
                    return;
                const m = new Module(el, this.getModuleParams(el, Module));
                m.parent = this;
                // if (!el.binded) el.binded = []
                // el.binded.push(key)
                return m;
            }).filter(Boolean);
            if (this.modules?.[key]) {
                // const current = forceArray(this.modules?.[key])?.filter((m: Component) => {
                //   if (m.el.parentElement && document.body.contains(m.el)) return true
                //   m.flush()
                //   return false
                // })
                array.unshift(...this.modules?.[key]);
            }
            if (array?.length)
                this.modules[key] = unforceArray(array);
        });
    }
    getModulesMap() {
        return {};
    }
    getModuleParams(el, componentConstructor) {
        return {
            parent: this,
            context: this.context
        };
    }
    /* BINDINGS ROUTERS */
    bindInternalRouter() {
        const types = ['panel', 'menu', 'search', 'popin'];
        this.routerLinks = [];
        types.forEach((type) => {
            const links = [].slice.call(this.el.querySelectorAll(`[data-${type}]`));
            links.forEach((link) => {
                if (link.hasListenerAttached)
                    return;
                link.addEventListener('click', this.onLinkClicked);
                link.hasListenerAttached = true;
                link.store = store[type];
                link.storeName = type;
            });
            this.routerLinks.push(...links);
        });
    }
    unbindInternalRouter() {
        this.routerLinks && this.routerLinks.forEach((link) => link.removeEventListener('click', this.onLinkClicked));
    }
    onLinkClicked = (event) => {
        const link = event.currentTarget;
        if ((event.ctrlKey || event.metaKey) && link.tagName.toLowerCase() === 'a')
            return false;
        event.preventDefault();
        event.stopPropagation();
        const routerData = getRouterData(link.getAttribute('data-' + link.storeName));
        const path = routerData.path || link.getAttribute('href');
        const tagName = routerData.tagName || link.storeName;
        if (tagName)
            tag.openPopin(tagName, link.storeName);
        if (path) {
            if (link.store.get() && link.store.get().includes(path.replace(getRoot(), '')))
                link.store.set(null);
            else
                link.store.set(path.replace(getRoot(), ''));
        }
        // if (path) link.store.set(path.replace((lastResolvedRoute() as Match).url, ''))
    };
    resize() {
        this.invoke('resize');
    }
    invoke(method) {
        each(this.modules, (module) => {
            if (isArray(module))
                invokeMap(module, method);
            else if (module)
                module[method]?.();
        });
    }
    flush() {
        // (this.el as any).binded = []
        this.flushed = true;
        this.bindEvents(false);
        this.unbindInternalRouter();
        this.invoke('flush');
    }
}
export default Component;
